import React, { useState, useEffect } from "react";

import BusinessSizeBreakdownInfoHeader from "./BusinessSizeBreakdownInfoHeader.jsx";
import BusinessSizeBreakdownInfoItem from "./BusinessSizeBreakdownInfoItem.jsx";

import { getGroupsData } from "../../../util/businessBreakdown.js";

import {
  WOSB,
  HUBZONE,
  SDVOSB,
  EDWOSB,
  VOSB,
  SMALL_BUSINESS,
  OTHER_THAN_SMALL,
  GROUP_TOTAL,
} from "../../../constants.js";

/**
 * @typedef {import("../../../jsdoc/BusinessSizeCount.js").BusinessSizeCount} BusinessSizeCount
 */

/**
 * BusinessSizeBreakdownInfo Component
 * @param {Object} props
 * @param {BusinessSizeCount[]} props.businessSizeCounts
 * @returns {React.JSX.Element}
 */
export default function BusinessSizeBreakdownInfo({ businessSizeCounts }) {
  const [groupsData, setGroupData] = useState(null);

  useEffect(() => {
    setGroupData(getGroupsData(businessSizeCounts));
  }, []);

  if (groupsData) {
    return (
      <table
        id="Summary2"
        role="grid"
        className="table table-bordered"
        summary="Counts of contract holders and contracts by business size"
      >
        <BusinessSizeBreakdownInfoHeader />

        <tbody role="rowgroup">
          <BusinessSizeBreakdownInfoItem group={EDWOSB} groupsData={groupsData[EDWOSB]} />
          <BusinessSizeBreakdownInfoItem group={HUBZONE} groupsData={groupsData[HUBZONE]} />
          <BusinessSizeBreakdownInfoItem group={OTHER_THAN_SMALL} groupsData={groupsData[OTHER_THAN_SMALL]} />
          <BusinessSizeBreakdownInfoItem group={SDVOSB} groupsData={groupsData[SDVOSB]} />
          <BusinessSizeBreakdownInfoItem group={SMALL_BUSINESS} groupsData={groupsData[SMALL_BUSINESS]} />
          <BusinessSizeBreakdownInfoItem group={VOSB} groupsData={groupsData[VOSB]} />
          <BusinessSizeBreakdownInfoItem group={WOSB} groupsData={groupsData[WOSB]} />
          <BusinessSizeBreakdownInfoItem group={GROUP_TOTAL} groupsData={groupsData[GROUP_TOTAL]} />
        </tbody>
      </table>
    );
  }
}
